// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e58d1e2c","94":"1ea7d12e","190":"5182fde1","389":"7fceed1d","443":"8038f88d","692":"98d95e44","763":"e008ed57","884":"ea745feb","895":"e6687125","969":"3e8fba53"}[chunkId] + ".chunk.js";
};